import { render } from "./englishRegistration.vue?vue&type=template&id=bdb13ad4&ts=true"
import script from "./englishRegistration.vue?vue&type=script&lang=ts"
export * from "./englishRegistration.vue?vue&type=script&lang=ts"

import "./englishRegistration.vue?vue&type=style&index=0&id=bdb13ad4&lang=css"

import exportComponent from "/home/devadm/tuyensinh-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__